import AppNavigator from "core/navigation/AppNavigator";
import NavigationLocations from "core/navigation/PublicNavigationLocations";
import AbstractNavigator from "core/navigation/abstractNavigator/AbstractNavigator";
import MapBrowserPath from "../mappers/mapBrowserPath/MapBrowserPath";
import { safeGetProperty } from "@/core/helpers/object/object";

export default class BrowserNavigator
  extends AbstractNavigator
  implements AppNavigator
{
  constructor(private _navigate: (path: string) => void) {
    super();
  }

  private convertParametersInPath(
    path: string,
    parameters?: Record<string, string | number>
  ): string {
    if (parameters) {
      const originalPath = path; // Store original path to check for path params

      // Handle path parameters (replace :paramName)
      Object.keys(parameters).forEach((key) => {
        const value = safeGetProperty(
          parameters as Record<string, string | number>,
          key
        );
        if (value !== undefined && value !== null) {
          path = path.replace(`:${key}`, value.toString());
        }
      });

      // Handle query parameters (add as query string)
      const queryParams = Object.keys(parameters)
        .filter((key) => !originalPath.includes(`:${key}`)) // Check against original path
        .map((key) => {
          const value = safeGetProperty(
            parameters as Record<string, string | number>,
            key
          );
          if (value === undefined || value === null) {
            return "";
          }
          return `${key}=${encodeURIComponent(value.toString())}`;
        })
        .filter((param) => param !== "")
        .join("&");

      if (queryParams) {
        path += `?${queryParams}`;
      }
    }
    return path;
  }

  protected navigateToLocation(
    location: NavigationLocations,
    parameters?: Record<string, string | number>
  ) {
    this._navigate(
      this.convertParametersInPath(
        MapBrowserPath.mapToBrowserPath(location),
        parameters
      )
    );
  }

  setNavigate(navigate: (path: string) => void) {
    this._navigate = navigate;
  }

  getNavigate() {
    return this._navigate;
  }
}
